export enum NoteConceptCode {
  CREDIT = 91,
  DEBIT = 92,
}
